// Only non-credential session metadata lives in memory; cookies remain server-controlled.
let generation = 0;
let sessionId = null;
let csrfRequest = null;
export const sessionGeneration = () => generation;
export const currentSessionId = () => sessionId;
export const markSession = id => { if (id !== sessionId) generation += 1; sessionId = id; };
export const invalidateSession = () => { generation += 1; sessionId = null; };
export const csrfCookie = () => document.cookie.split('; ').find(value => value.startsWith('__Host-maldhowr_csrf='))?.split('=').slice(1).join('=');
export const ensureCsrf = client => {
  if (!csrfRequest) csrfRequest = client.get('/auth/csrf').then(response => response.data.csrfToken).finally(() => { csrfRequest = null; });
  return csrfRequest;
};

export const removeLegacySession = () => {
  try {
    localStorage.removeItem('somafro_token');
    localStorage.removeItem('maldhowr_session_activity');
  } catch { console.warn('Legacy session storage could not be removed; it is no longer accepted.'); }
};